import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "../../_libs/material-module/material.module";
import { CtaButtonLayoutIconTitleComponent } from "./cta-button--layouts/cta-button-layout-icon-title/cta-button-layout-icon-title.component";
import { CtaButtonLayoutSubtitleNotePriceComponent } from "./cta-button--layouts/cta-button-layout-subtitle-note-price/cta-button-layout-subtitle-note-price.component";
import { CtaButtonComponent } from "./cta-button/cta-button.component";
import { CtaButtonFeaturesComponent } from "./cta-button-features/cta-button-features.component";
import { CtaButtonFeaturesGroupComponent } from "./cta-button-features-group/cta-button-features-group.component";
import { CtaButtonGroupControlComponent } from "./cta-button-group-control/cta-button-group-control.component";
import { CtaPointerComponent } from "./cta-pointer/cta-pointer.component";
import { CtaButtonGroupComponent } from "./cta-button-group/cta-button-group.component";
// import { SwiperModule } from "@sonrisa-dev/ngx-swiper-wrapper-sonfork";
import { FeaturesListLayoutComponent } from "./cta-button-features--layouts/features-list-layout/features-list-layout.component";
import { CtaButtonLayoutTitleSubtitleComponent } from "./cta-button--layouts/cta-button-layout-title-subtitle/cta-button-layout-title-subtitle.component";
import { FeaturesSimpleListLayoutComponent } from "./cta-button-features--layouts/features-simple-list-layout/features-simple-list-layout.component";
import { CtaButtonLayoutImageTitleSubtitleComponent } from "./cta-button--layouts/cta-button-layout-image-title-subtitle/cta-button-layout-image-title-subtitle.component";
import { PriceDisplayModule } from "@dodo/price-display/price-display.module";
import { CtaButtonLayoutImagesTitleComponent } from "./cta-button--layouts/cta-button-layout-images-title/cta-button-layout-images-title.component";
import { FeaturesSimpleListLayoutEnergyComponent } from "./cta-button-features--layouts/features-simple-list-layout-energy/features-simple-list-layout-energy.component";
import { TealiumModule } from "tealium/tealium.module";
import { CtaToggleButtonComponent } from "./cta-toggle-buttons/cta-toggle-button/cta-toggle-button.component";
import { CtaToggleButtonGroupComponent } from "./cta-toggle-buttons/cta-toggle-button-group/cta-toggle-button-group.component";
import { CtaToggleButtonGroupControlComponent } from "./cta-toggle-buttons/cta-toggle-button-group-control/cta-toggle-button-group-control.component";
import { CtaButtonLayoutPromoDiscountsComponent } from "./cta-button--layouts/cta-button-layout-promo-discounts/cta-button-layout-promo-discounts.component";
import { CtaButtonLayoutInternetDataComponent } from "./cta-button--layouts/cta-button-layout-internet-data/cta-button-layout-internet-data.component";
import { CtaButtonLayoutInternetSpeedComponent } from "./cta-button--layouts/cta-button-layout-internet-speed/cta-button-layout-internet-speed.component";
import { CtaButtonLayoutInternetContractLengthComponent } from "./cta-button--layouts/cta-button-layout-internet-contract-length/cta-button-layout-internet-contract-length.component";
import { CtaButtonMultipleSelectGroupComponent } from "./cta-button-multiple-select-group/cta-button-multiple-select-group.component";
import { CtaButtonMultipleSelectGroupControlComponent } from "./cta-button-multiple-select-group-control/cta-button-multiple-select-group-control.component";
import { CtaButtonMultipleSelectComponent } from "./cta-button-multiple-select/cta-button-multiple-select.component";
import { OrdinalDateTimePipe } from "@dodo/dodo-pipes/ordinal-date.pipe";
import { CtaButtonLayoutCallPackComponent } from "./cta-button--layouts/cta-button-layout-call-pack/cta-button-layout-call-pack.component";
import { DodoMatComponentsCommonModule } from "_libs/dodo-mat-components/dodo-mat-components-common.module";
import { CtaButtonGroupDataPlansComponent } from "./cta-button-group-data-plans/cta-button-group-data-plans.component";

const layoutComponents = [
	CtaButtonLayoutIconTitleComponent,
	CtaButtonLayoutInternetDataComponent,
	CtaButtonLayoutInternetSpeedComponent,
	CtaButtonLayoutSubtitleNotePriceComponent,
	CtaButtonLayoutTitleSubtitleComponent,
	CtaButtonLayoutImageTitleSubtitleComponent,
	CtaButtonLayoutImagesTitleComponent,
	CtaButtonLayoutPromoDiscountsComponent,
	FeaturesListLayoutComponent,
	FeaturesSimpleListLayoutComponent,
	FeaturesSimpleListLayoutEnergyComponent,
	CtaButtonLayoutInternetContractLengthComponent,
	CtaButtonLayoutCallPackComponent,
];

const components = [
	CtaPointerComponent,
	CtaToggleButtonComponent,
	CtaToggleButtonGroupComponent,
	CtaToggleButtonGroupControlComponent,
	CtaButtonComponent,
	// CtaButtonNbnComponent,
	// CtaButtonModemComponent,
	CtaButtonGroupComponent,
	CtaButtonGroupControlComponent,
	CtaButtonFeaturesComponent,
	CtaButtonFeaturesGroupComponent,
	CtaButtonMultipleSelectComponent,
	CtaButtonMultipleSelectGroupComponent,
	CtaButtonMultipleSelectGroupControlComponent,
	CtaButtonGroupDataPlansComponent,
];

const allComponents = [...components, ...layoutComponents];

@NgModule({
	imports: [
		CommonModule,
		MaterialModule,
		// SwiperModule,
		PriceDisplayModule,
		TealiumModule,
		DodoMatComponentsCommonModule,
	],
	declarations: [...allComponents, layoutComponents, OrdinalDateTimePipe],
	exports: [...allComponents],
	// entryComponents: [layoutComponents],
})
export class DodoCtaButtonsModule {}
